import { createElement } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

const SvgInfoIcon = (props: SvgIconProps) =>
  createElement(
    SvgIcon,
    props,
    <path
      clipRule="evenodd"
      d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m4.651 12.651a6.58 6.58 0 0 1-9.342.04 6.576 6.576 0 0 1 .04-9.342 6.58 6.58 0 0 1 9.342-.04 6.576 6.576 0 0 1-.04 9.342M12 9.858a1.11 1.11 0 1 0 .001-2.222A1.11 1.11 0 0 0 12 9.858m.924 5.595v-3.662a.925.925 0 0 0-1.848 0v3.662a.924.924 0 1 0 1.848 0"
      fill="currentColor"
      fillRule="evenodd"
    />,
  )
export default SvgInfoIcon
